import {
    OPEN_MODAL,
    CLOSE_MODAL,
    OPEN_LOADER,
    CLOSE_LOADER
} from '../Action-type/Index';

export function openModal(children) {
    return {
        type: OPEN_MODAL,
        payload: {
            children
        }
    }
}

export function closeModal() {
    return {
        type: CLOSE_MODAL
    }
}

export function openLoader() {
    return {
        type: OPEN_LOADER
    }
}

export function closeLoader() {
    return {
        type: CLOSE_LOADER
    }
}